/**
 * 토스 카드 (DESIGN_SPEC 6장). 받는 멤버 아바타 32 + 이름 + 소개 한 줄 + "○○과 이어가기"(높이 40).
 */
import { getMember } from '@config/members/index.js';
import { withJosa } from '@shared/korean.js';
import { Avatar } from '../../components/Avatar.jsx';
import { Button } from '../../components/Button.jsx';

export function TossCard({ memberKey, busy, onFollow }) {
    const member = getMember(memberKey);
    if (!member) {
        return null;
    }
    return (
        <div className="flex flex-col gap-2.5 rounded-card bg-surface-sunken p-3">
            <div className="flex items-center gap-2">
                <Avatar memberKey={memberKey} size={32} />
                <div className="flex min-w-0 flex-col">
                    <span className="text-label">{member.name}</span>
                    <span className="truncate text-micro font-normal text-text-secondary">{member.line}</span>
                </div>
            </div>
            <Button size="sm" className="rounded-[10px]" busy={busy} onClick={onFollow}>
                {withJosa(member.name, '과', '와')} 이어가기
            </Button>
        </div>
    );
}
